import { render, staticRenderFns } from "./applygdtdouyingWx.vue?vue&type=template&id=32ee0f5c&scoped=true&"
import script from "./applygdtdouyingWx.vue?vue&type=script&lang=js&"
export * from "./applygdtdouyingWx.vue?vue&type=script&lang=js&"
import style0 from "./applygdtdouyingWx.vue?vue&type=style&index=0&id=32ee0f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ee0f5c",
  null
  
)

export default component.exports